import { render, staticRenderFns } from "./UnitTrainingPerson.vue?vue&type=template&id=67573d02&scoped=true"
import script from "./UnitTrainingPerson.vue?vue&type=script&lang=js"
export * from "./UnitTrainingPerson.vue?vue&type=script&lang=js"
import style0 from "./UnitTrainingPerson.vue?vue&type=style&index=0&id=67573d02&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67573d02",
  null
  
)

export default component.exports